import type { RouteParamsGeneric } from 'vue-router'

import type { RouteExistsGuard } from '@backmarket/nuxt-layer-base/plugins/routeExists'
/**
 * Accepts only alphanumeric characters and hyphens
 */
const validParamRegex = /^[a-zA-Z0-9-]+$/

function checkPathParams(
  pathParams: RouteParamsGeneric,
):
  | { invalid: true; invalidParam: string; invalidParamValue: string }
  | { invalid: false } {
  if (!validParamRegex.test(String(pathParams.pageName))) {
    return {
      invalid: true,
      invalidParam: 'pageName',
      invalidParamValue: String(pathParams.pageName),
    }
  }

  if (
    pathParams.pageCategory &&
    !validParamRegex.test(String(pathParams.pageCategory))
  ) {
    return {
      invalid: true,
      invalidParam: 'pageCategory',
      invalidParamValue: String(pathParams.pageCategory),
    }
  }

  return { invalid: false }
}

/**
 *
 * Checks that a CMS route has valid params (pageName and pageCategory)
 * Valid params are alphanumeric characters and hyphens
 * This avoids calling the content service for invalid params
 */
export const routeHasValidParams: RouteExistsGuard = (to) => {
  const result = checkPathParams(to.params)

  if (result.invalid) {
    return {
      message: `Invalid CMS page route param: ${result.invalidParam}:${result.invalidParamValue}`,
      status: 404,
    }
  }

  return true
}
